import { isAxiosError } from 'axios';
import i18next from 'i18next';
import { toast } from 'sonner';

const BLOCKED_MESSAGES = [
    'impersonation-not-allowed',
    'impersonation-read-only',
];

/**
 * Explains a 403 caused by the impersonation guard, so the administrator
 * doesn't mistake it for a bug in the screen they are reproducing.
 */
export function notifyImpersonationBlocked(error: unknown): void {
    if (!isAxiosError(error) || error.response?.status !== 403) {
        return;
    }

    const message = error.response.data?.message;

    if (BLOCKED_MESSAGES.includes(message)) {
        toast.warning(i18next.t(`impersonation.errors.${ message }`, { ns: 'pages' }));
    }
}
